import React, { useState } from 'react';
import logo1 from 'Assets/img/sign/logo.png';
import logo2 from 'Assets/img/sign/logo@2x.png';
import logo3 from 'Assets/img/sign/logo@3x.png';
import icX1 from 'Assets/img/sign/ic_x.png';
import icX2 from 'Assets/img/sign/ic_x@2x.png';
import icX3 from 'Assets/img/sign/ic_x@3x.png';
import logoHobien1 from 'Assets/img/sign/logo_hobien.png';
import logoHobien2 from 'Assets/img/sign/logo_hobien@2x.png';
import logoHobien3 from 'Assets/img/sign/logo_hobien@3x.png';
import { getImageSet } from 'Util/DataUtils';
import LoginSection from './components/LoginSection';
import JoinSection from './components/JoinSection';
import JoinViSection from './components/JoinViSection';
import CompleteSection from './components/CompleteSection';
import FindPasswordSection from './components/FindPasswordSection';
import Scrollbars from 'react-custom-scrollbars-2';
import { useSelector } from 'react-redux';
import PasswordCompleteSection from './components/PasswordCompleteSection';
import FindPasswordViSection from './components/FindPasswordViSection';

const logo = getImageSet([logo1, logo2, logo3]);
const icX = getImageSet([icX1, icX2, icX3]);
const logoHobien = getImageSet([logoHobien1, logoHobien2, logoHobien3]);
const TYPE_LOGIN = 'TYPE_LOGIN';
const TYPE_JOIN = 'TYPE_JOIN';
const TYPE_JOIN_COMPLETED = 'TYPE_JOIN_COMPLETED';
const TYPE_FIND_PASSWORD = 'TYPE_FIND_PASSWORD';
const TYPE_PASSWORD_COMPLETE = 'TYPE_PASSWORD_COMPLETE';

const LeftSide = () => {
  const [type, setType] = useState(TYPE_LOGIN);
  const [data, setData] = useState(null);
  const { country } = useSelector(state => state.settings);

  const onCompleted = propsData => {
    setData(propsData);
    setType(TYPE_JOIN_COMPLETED);
  };

  const renderSection = type => {
    if (type === TYPE_LOGIN) {
      return <LoginSection onChangeJoin={() => setType(TYPE_JOIN)} onChangeFindPassword={() => setType(TYPE_FIND_PASSWORD)} />;
    }
    if (type === TYPE_JOIN) {
      if (country === 'vi') {
        return <JoinViSection onChangeLogin={() => setType(TYPE_LOGIN)} onCompleted={onCompleted} />;
      }
      return <JoinSection onChangeLogin={() => setType(TYPE_LOGIN)} onCompleted={onCompleted} />;
    }
    if (type === TYPE_JOIN_COMPLETED) {
      return <CompleteSection data={data} />;
    }
    if (type === TYPE_FIND_PASSWORD) {
      if (country === 'vi') {
        return <FindPasswordViSection onChangeLogin={() => setType(TYPE_LOGIN)} onCompleted={() => setType(TYPE_PASSWORD_COMPLETE)} />;
      }
      return <FindPasswordSection onChangeLogin={() => setType(TYPE_LOGIN)} onCompleted={() => setType(TYPE_PASSWORD_COMPLETE)} />;
    }
    if (type === TYPE_PASSWORD_COMPLETE) {
      return <PasswordCompleteSection onChangeLogin={() => setType(TYPE_LOGIN)} />;
    }
  };

  return (
    <Scrollbars
      className="rct-scroll"
      autoHide
      autoHideDuration={100}
      style={{
        height: 'calc(var(--vh, 1vh) * 100)',
        flex: 1,
      }}
    >
      <div className="logo-image">
        <img {...logo} alt="logo" />
        {country === 'vi' && (
          <>
            <img {...icX} alt="x" style={{ marginRight: '12px', marginLeft: '2px' }} />
            <img {...logoHobien} alt="logoHobien" />
          </>
        )}
      </div>

      <div className="left-container">{renderSection(type)}</div>
    </Scrollbars>
  );
};

export default LeftSide;
